var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSchedule = function SvgIconSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M13.125 18.75a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0-8.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M14.119 15.625 12.5 14.006V11.25h1.25v2.244l1.25 1.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M17.5 3.75a1.25 1.25 0 0 0-1.25-1.25h-2.5V1.25H12.5V2.5h-5V1.25H6.25V2.5h-2.5A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h2.5v-1.25h-2.5V3.75h2.5V5H7.5V3.75h5V5h1.25V3.75h2.5V7.5h1.25z"
  })));
};
export default SvgIconSchedule;